import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { SASDashboardSelectStyles, SASSMenuPropsStyles } from "../ui/styles/inputStyles";
import { colors } from "../ui/colors";
import { getTypeColor, JobType } from "./JobsWidgetWithWeek";

interface Prop {
  job: string;
  setJob: (value: string) => void;
  period: string;
  setPeriod: (value: string) => void;
}

export default function HeaderJobsCalendar({ job, setJob, period, setPeriod }: Prop) {
  const activeColor = job === "all" ? "inherit" : getTypeColor(job as JobType);

  return (
    <Box display={"flex"} gap={1}>
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <Select
          value={job}
          onChange={(e) => setJob(e.target.value)}
          sx={{
            ...SASDashboardSelectStyles,

            "& .MuiSelect-select": {
              color: `${activeColor} !important`,
              fontWeight: job === "all" ? 500 : 700,
              WebkitTextFillColor: activeColor === "inherit" ? "initial" : activeColor,
            },

            "& .MuiSelect-icon": {
              color: activeColor,
            },

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: job === "all" ? "rgba(224, 224, 224, 0.9)" : activeColor,
              borderWidth: job === "all" ? "1px" : "1px",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: job === "all" ? "rgba(251, 142, 0, 0.35)" : activeColor,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: job === "all" ? colors.orange.base : activeColor,
            },
          }}
          MenuProps={SASSMenuPropsStyles}
        >
          <MenuItem value="all">All Jobs</MenuItem>
          <MenuItem value="residential">Residential</MenuItem>
          <MenuItem value="commercial">Commercial</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 50 }}>
        <Select value={period} onChange={(e) => setPeriod(e.target.value)} sx={SASDashboardSelectStyles} MenuProps={SASSMenuPropsStyles}>
          <MenuItem value="today">Today</MenuItem>
          <MenuItem value="weekly">Week</MenuItem>
          <MenuItem value="monthly">Month</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
